import {
  IconCalendar,
  IconClock,
  IconCurrencyDollar,
  IconLanguage,
} from '@tabler/icons-react';
import type { Icon } from '@tabler/icons-react';
import type { CourseDetail } from '@admitly/shared';
import { centsToAud, formatIntakes } from '../../lib/format.js';

type Props = {
  course: CourseDetail;
};

type Stat = {
  icon: Icon;
  label: string;
  value: string;
};

export function CourseStatStrip({ course }: Props) {
  const stats: Stat[] = [
    {
      icon: IconClock,
      label: 'Duration',
      value: course.durationText ?? '—',
    },
    {
      icon: IconCurrencyDollar,
      label: 'Annual fee',
      value: centsToAud(course.annualTuitionCents),
    },
    {
      icon: IconCalendar,
      label: 'Intakes',
      value: formatIntakes(course.intakeMonths),
    },
    {
      icon: IconLanguage,
      label: 'IELTS',
      value: course.ieltsOverall ?? '—',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-line border border-line rounded-xl bg-white overflow-hidden">
      {stats.map((s) => (
        <div key={s.label} className="px-5 py-4">
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.12em] text-muted-soft font-semibold mb-1">
            <s.icon size={12} />
            {s.label}
          </div>
          <div className="font-serif text-xl text-ink tracking-tightish leading-tight">
            {s.value}
          </div>
        </div>
      ))}
    </div>
  );
}
